import React, { useState } from 'react';

import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';

// 1st) Load the bootstrap css stylesheet
import "bootstrap/dist/css/bootstrap.min.css";
// 2nd) Load the customised css stylesheet
import './index.css';

//import { BrowserRouter, Routes, Route } from "react-router-dom"
import NavbarApp from './NavbarApp';
import App from './App';

/*import NavbarApp from './NavbarApp';
import IndexOcean from './IndexOcean';
import LandingPage from './LandingPage';*/



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NavbarApp />
    <App />
  </React.StrictMode>
);



/*function App2() {
  const [color, setCss] = useState('white')

  return (
      <BrowserRouter>
        <Routes>
          <Route path='/coffeePulse' element={<LandingPage />}/>
          <Route path='/index.html' element={<IndexOcean />}/>
          <Route path='/' element={<IndexOcean />}/>
        </Routes>
      </BrowserRouter>
  );

}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NavbarApp />
    <App2 />
  </React.StrictMode>
);
*/




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
